export default {
	serverUrl: process.env.SERVER_URL || 'https://cedulas.tramites-express.com/api/v1',
	baserUrl: process.env.BASE_URL || 'https://cedulas.tramites-express.com',
	f08Url: 'https://f08.tramites-express.com',
	cetaUrl: 'https://ceta.tramites-express.com',
	contactoUrl: 'https://tramites-express.com/contacto',
	caiUrl: 'https://solicitud-cai.com/',
	informesUrl: 'https://informe.com.ar',
	tramitaYa: 'https://tramites-express.com',
	commonUrl: 'https://tramites-express.com/common/v1/api'
}

